export enum Roles {
  TemplateAdicionar = "TemplateAdicionar",
  TemplateEditar = "TemplateEditar",
  TemplateExcluir = "TemplateExcluir",
}
